<template>
<div class="all">

<mt-header title="选择体检套餐">
  <!-- <mt-button icon="back" slot="left" @click="myclose"></mt-button> -->
</mt-header>

<ul class="list">
	<li class="item" v-for="v in list" :key="v.id">
	<p>{{v.name|title}}</p>
	<p class="btn">
	   <mt-button size="small" class="btn-orange" @click="showdetail(v)" v-if="v.price>0">查看详情</mt-button>
	   <mt-button size="small" class="btn-blue" @click="buy(v)">选择套餐</mt-button>
	</p>
	</li>
</ul>

<mt-popup v-model="show">
<div class="dt">
<div class="row" @click="closedeteail">
	<h4>套餐详情</h4>
</div>
<div class="row">
<table>
	<tr>
		<th>项目</th>
		<th>说明</th>
	</tr>
	<tr v-for="v in detail" :key="v.id">
		<td>{{v.type}}(¥ {{v.price}})</td>
		<td>{{v.info}}</td>
	</tr>
</table>
</div>
<div class="row pd">
	<mt-button @click="closedeteail" type="danger" size="large" :modal="false">关闭</mt-button>
</div>	
</div>	
</mt-popup>


</div>
</template>

<style scoped>
h4{text-align: center;background: rgb(0,144,255);color:white;width:100%;}
.pd{padding:.5rem 1rem 2rem;}
table{border-collapse: collapse;}
td,th{border: 1px solid #ddd;padding:.5rem .3rem;}
.all,.dt{width:100vw;height:100vh;overflow: auto;}	
.item{padding:1rem .5rem;}
.price{float: right;color:red;}
p.btn{text-align: right;margin-top: 1rem;}
.btn-orange{color:orange;border:1px solid orange;height:1.7rem;}
.btn-blue{color:rgb(0,144,255);border:1px solid rgb(0,144,255);height:1.7rem;}
</style>

<script>

export default {
	props:{
		hos:String,
		list:Array,
	},
	data:function(){
		return {
			detail:"",
			show:false,
		}
	},
	methods:{
		buy:function(v){
          this.$emit("close",v);
		},
		closedeteail:function(){
			this.show=false;
		},
		showdetail:function(v){
		  var _this=this;
		  v.hos=this.hos;
		  fun.post(mydata.apiuser+"tcdetail",v,function(d){
		  	//console.log(d);
		  	if(d.status==1){
		  		_this.detail=d.info;
		  		_this.show=true;
		  	}else{
		  		_this.$toast(d.info);
		  	}
		  })	
		}

	}
}	
</script>


// WEBPACK FOOTER //
// src/lib/tc.vue